export var HTTP_STATUS_CODES = {
    UNAUTHORIZED: 401,
};
export var NodeAuthMiddlewareErrorCodes = {
    OKTA_VALIDATION_NEEDED: 1,
    CLA_VALIDATION_NEEDED: 2,
};
export var RefreshFailureReasons = {
    /** Call to Okta token refresh endpoint failed with error !== 401 */
    TOKEN_REFRESH_FAILED: 'TOKEN_REFRESH_FAILED',
    /** The refresh call succeeded, but the new token didn't work, error still === 401 */
    INVALID_TOKEN_AFTER_REFRESH: 'INVALID_TOKEN_AFTER_REFRESH',
};
